import theme from '@css/theme.style.json';

const layers = [
  {
    id: 'search-geometry',
    type: 'fill',
    source: 'search-geometry',
    paint: {
      'fill-color': '#000',
      'fill-opacity': 0.2,
      'fill-antialias': false,
    },
  },
  {
    id: 'fietssnelwegen',
    type: 'line',
    source: 'fietssnelwegen',
    filter: ['==', ['get', 'BEFIETSBAAR'], 1],
    paint: {
      'line-color': [
        'case',
        ['==', ['get', 'lowPro'], true],
        '#0b78d4',
        '#acbfd0', 
      ],
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2.5,
        2, 
      ],
    },
  },
  {
    id: 'fietssnelwegen-dashed',
    type: 'line',
    source: 'fietssnelwegen',
    filter: ['==', ['get', 'BEFIETSBAAR'], 0],
    paint: {
      'line-color': [
        'case',
        ['==', ['get', 'lowPro'], true],
        '#0b78d4',
        '#acbfd0', 
      ],
      'line-width': 2,
      'line-dasharray': [2, 2],
    },
  },
  {
    id: 'fietssnelwegen-icons',
    type: 'symbol',
    source: 'fietssnelwegen',
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 200,
      'icon-image': [
        'case',
        ['==', ['get', 'lowPro'], true],
        'fietssnelweg',
        'fietssnelweg-grey', 
      ],
      'icon-rotation-alignment': 'viewport',
      'icon-size': 0.7,
      'text-field': '{FSW_NUMMER}',
      'text-size': 7,
      'text-font': ['Open Sans Bold'],
      'text-rotation-alignment': 'viewport',
      'text-offset': [0, 0.675],
    },
    paint: {
      'text-color': theme.color.common.white,
    },
  },
  {
    id: 'fietssnelwegen-hover',
    type: 'line',
    source: 'fietssnelwegen',
    paint: {
      'line-color': '#000',
      'line-opacity': 0,
      'line-width': 10,
    },
  },
  {
    id: 'vacancy-route',
    type: 'line',
    source: 'vacancy-route',
    paint: {
      'line-color': [
        'case',
        ['in', ['get', 'mode'], 'WALK,pedestrian'],
        theme.color['transport-types'].walking,
        ['in', ['get', 'mode'], 'BICYCLE,bicycle'],
        theme.color['transport-types'].bike,
        ['in', ['get', 'mode'], 'E-BIKE'],
        theme.color['transport-types']['e-bike'],
        ['in', ['get', 'mode'], 'CAR,auto'],
        theme.color['transport-types'].car,
        ['in', ['get', 'mode'], 'RAIL,BUS,TRAM'],
        theme.color['transport-types'].ov,
        theme.color.common.grey.xlight,
      ],
      'line-width': 5,
    },
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
  },
  {
    id: 'nearby-stops',
    type: 'symbol',
    source: 'nearby-stops',
    layout: {
      'icon-image': [
        'match',
        ['get', 'agency'],
        'delijn', 'bus-stop',
        'nmbs', 'train-station',
        'bus-stop',
      ],
      'icon-allow-overlap': true,
      'icon-size': 0.5,
    },
  },
  {
    id: 'hovered-nearby-stop',
    type: 'symbol',
    source: 'hovered-nearby-stop',
    layout: {
      'icon-image': [
        'match',
        ['get', 'agency'],
        'delijn', 'bus-stop-active',
        'nmbs', 'train-station-active',
        'bus-stop-active',
      ],
      'icon-allow-overlap': true,
      'icon-size': 0.6,
    },
  },
  {
    id: 'vacancies-clusters',
    type: 'symbol',
    source: 'vacancies',
    filter: ['has', 'point_count'],
    layout: {
      'icon-image': 'sdf-cluster',
      'icon-size': [
        'step',
        ['to-number', ['get', 'sum']],
        0.55,
        100, 0.6,
        1000, 0.65,
      ],
      'icon-allow-overlap': true,
      'text-field': '{sum}',
      'text-size': 12,
      'text-font': ['Open Sans Bold'],
      'text-allow-overlap': true,
    },
    paint: {
      'icon-color': [
        'case',
        ['boolean', ['feature-state', 'highlight'], false], theme.color.primary.dark,
        theme.color.tertiary.main,
      ],
      'icon-halo-color': theme.color.tertiary.main,
      'icon-halo-width': 1,
      'icon-halo-blur': 1,
      'text-color': theme.color.common.white,
    },
  },
  {
    id: 'hovered-vacancy',
    type: 'symbol',
    source: 'vacancies',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'isJobAggregator'], true],
        'intrim-with-counter-highlighted',
        ['==', ['get', 'hasHouseNb'], false],
        'work-no-address-with-counter-highlighted',
        'work-with-counter-highlighted',
      ],
      'icon-allow-overlap': true,
      'icon-size': 0.55,
      'text-field': '{vacanciesCount}',
      'text-font': ['Open Sans Bold'],
      'text-anchor': 'center',
      'text-size': [
        'case',
        ['==', ['length', ['to-string', ['get', 'vacanciesCount']]], 3], 9,
        10,
      ],
      'text-allow-overlap': true,
      'text-offset': [1, -1],
    },
    paint: {
      'text-color': theme.color.common.white,
      'text-opacity': [
        'case',
        ['boolean', ['feature-state', 'highlight'], false], 1,
        0,
      ],
      'icon-opacity': [
        'case',
        ['boolean', ['feature-state', 'highlight'], false], 1,
        0,
      ],
    },
  },
  {
    id: 'vacancies',
    type: 'symbol',
    source: 'vacancies',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'isJobAggregator'], true],
        'intrim-with-counter',
        ['==', ['get', 'hasHouseNb'], false],
        'work-no-address-with-counter',
        'work-with-counter',
      ],
      'icon-allow-overlap': true,
      'icon-size': 0.55,
      'text-field': '{vacanciesCount}',
      'text-font': ['Open Sans Bold'],
      'text-anchor': 'center',
      'text-size': [
        'case',
        ['==', ['length', ['to-string', ['get', 'vacanciesCount']]], 3], 9,
        10,
      ],
      'text-allow-overlap': true,
      'text-offset': [1, -1],
    },
    paint: {
      'text-color': theme.color.common.white,
      'text-opacity': [
        'case',
        ['boolean', ['feature-state', 'highlight'], false], 0,
        1,
      ],
      'icon-opacity': [
        'case',
        ['boolean', ['feature-state', 'highlight'], false], 0,
        1,
      ],
    },
  },
  {
    id: 'vacancy',
    type: 'symbol',
    source: 'vacancy',
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'isJobAggregator'], true],
        'intrim',
        ['==', ['get', 'hasHouseNb'], false],
        'work-no-address',
        'work',
      ],
      'icon-size': 0.55,
      'icon-allow-overlap': true,
    },
  },
  {
    id: 'sollicitation',
    type: 'symbol',
    source: 'vacancy',
    layout: {
      'icon-image': 'sollicitation',
      'icon-size': 0.55,
      'icon-allow-overlap': true,
    },
  },
  {
    id: 'home',
    type: 'symbol',
    source: 'home',
    layout: {
      'icon-image': 'home',
      'icon-size': 0.55,
      'icon-allow-overlap': true,
    },
  },
]

export default layers;